<template>
<div id="app">
	<!-- 通用头部 -->
	<pc-header v-if="!isMobile"></pc-header>
	
	<transition name="fade">
		<router-view :style="'min-height:'+minHeight+'px;'" :class="{'mobile-page':isMobile}" />
	</transition>

	<!-- 通用底部 -->
	<pc-footer v-if="!isMobile"></pc-footer>
</div>
</template>

<script>
import pcHeader from "./components/header"
import pcFooter from "./components/footer"
export default {
	name: 'App',
	data () {
		return {
			winHeight:0,
		}
	},
	components:{
		pcHeader,
		pcFooter
	},
	computed: {
		minHeight(){	//主体页面高度（防止footer不在最底部）
			const { headerHeight, footerHeight } = this.$store.state
			return parseInt(this.winHeight - headerHeight - footerHeight)
		}
	},
	
	created() {
		//判断当前打开是移动还是PC
		let isMobile = this.$common.isMobile()
		//let isMobile = false
		this.$store.commit('changeIsMobile',isMobile)
		
		//初始化
		this.$store.dispatch('init').then((res)=>{
			const { code } = this.$route.meta
			this.$store.commit('changeNavCode',code) 
			this.$isResolve()
		})
		
		this.winHeight = document.documentElement.clientHeight
		window.onresize = ()=>{
			this.winHeight = document.documentElement.clientHeight
		}
		
	},
	
	methods:{
		
	}
}
</script>

<style lang="less">
@import '~@/static/css/common.less';
// .page-main{
// 	min-height:500px;
// }

.fade-leave-to{ opacity: 0; }
.fade-leave-active{ transition: opacity .5s; }
.fade-enter{ opacity: 0; }
.fade-enter-active{ transition: opacity .5s; transition-delay:.5s; }
.mobile-page{ background:#fff; }
</style>



// WEBPACK FOOTER //
// src/App.vue